"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformMediaQueryObject = exports.getSize = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _constants = require("../../constants");
/**
 * Transform media query (prop or inline) to size inline media query
 *
 * @param {string} data.defaultSize Either `xs` or `md`
 * @param {boolean} data.fullScreen Replaces default size with `fullScreen` is true
 * @param {object} data.object Inline media query or legacy media query object
 * @param {string} data.valueKey Nested value key for legacy media query object
 * @returns {object} Inline media query object
 */
var transformMediaQueryObject = function transformMediaQueryObject(_ref) {
  var defaultSize = _ref.defaultSize,
    fullScreen = _ref.fullScreen,
    object = _ref.object,
    valueKey = _ref.valueKey;
  return Object.entries(object).reduce(function (accumulator, _ref2) {
    var _Object$assign;
    var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return Object.assign({}, accumulator, (_Object$assign = {}, _Object$assign[key] = (valueKey ? value[valueKey] : value) === true ? _constants.MODAL_SIZES.FULL_SCREEN : defaultSize, _Object$assign));
  }, {
    default: fullScreen ? _constants.MODAL_SIZES.FULL_SCREEN : defaultSize
  });
};

/**
 * Translate deprecated dimension props to the new `size` prop.
 * Required for backward compatibility.
 *
 * @param {boolean|object} props.fullScreen
 * @param {object} props.mediaQuery
 * @param {string|object} props.size
 * @param {boolean} props.wide
 * @returns {string|object} Size enum value or inline media query object
 */
exports.transformMediaQueryObject = transformMediaQueryObject;
var getSize = function getSize(_ref4) {
  var fullScreen = _ref4.fullScreen,
    mediaQuery = _ref4.mediaQuery,
    size = _ref4.size,
    wide = _ref4.wide;
  var defaultSize = wide ? _constants.MODAL_SIZES.MD : _constants.MODAL_SIZES.XS;
  if (wide && !mediaQuery && (0, _typeof2.default)(fullScreen) !== 'object' && (0, _typeof2.default)(size) !== 'object') {
    return _constants.MODAL_SIZES.MD;
  }
  if (mediaQuery) {
    return transformMediaQueryObject({
      defaultSize: defaultSize,
      fullScreen: fullScreen,
      object: mediaQuery,
      valueKey: _constants.MODAL_SIZES.FULL_SCREEN
    });
  }
  if (fullScreen) {
    if (typeof fullScreen === 'boolean') {
      return _constants.MODAL_SIZES.FULL_SCREEN;
    }
    if ((0, _typeof2.default)(fullScreen) === 'object') {
      return transformMediaQueryObject({
        defaultSize: defaultSize,
        object: fullScreen
      });
    }
  }
  if ((0, _typeof2.default)(size) === 'object') {
    return Object.assign({
      default: defaultSize
    }, size);
  }
  return size;
};
exports.getSize = getSize;